import React, { useState, useEffect } from 'react';
import { adminApi, oesApi, assessmentApi, organizationApi } from '../../services/api';
import CustomSelect from '../common/CustomSelect';
import { useLabels } from '../../providers/LabelsProvider';
import { useT } from '../../providers/I18nProvider';

function UserEditSidebar({ isOpen, onClose, user, onUserUpdated }) {
  const labels = useLabels();
  const t = useT();
  const [formData, setFormData] = useState({
    // User fields
    username: '',
    email: '',
    password: '',
    confirm_password: '',
    role: 'user',
    is_active: true,
    // UserInfo fields
    first_name: '',
    last_name: '',
    title: '',
    office: '',
    mobile: '',
    city: '',
    country: '',
    visibility: 0,
    org_id: null,
  });
  const [avatar, setAvatar] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [oesList, setOesList] = useState([]);
  const [organizationsList, setOrganizationsList] = useState([]);
  const role = localStorage.getItem('role');
  const isGlobalAdmin = role === 'global_admin';

  const countries = [
    { code: '', name: 'Select country' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BR', name: 'Brazil' },
    { code: 'BN', name: 'Brunei' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'EE', name: 'Estonia' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'GR', name: 'Greece' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JP', name: 'Japan' },
    { code: 'KR', name: 'Korea (South)' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MX', name: 'Mexico' },
    { code: 'MA', name: 'Morocco' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NO', name: 'Norway' },
    { code: 'PA', name: 'Panama' },
    { code: 'PE', name: 'Peru' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'ES', name: 'Spain' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'TR', name: 'Turkey' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Vietnam' },
  ];

  useEffect(() => {
    if (isOpen) {
      fetchOesList();
      if (isGlobalAdmin || role === 'admin') {
        fetchOrganizations();
      }
    }
  }, [isOpen, isGlobalAdmin, role]);

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || '',
        email: user.email || '',
        password: '',
        confirm_password: '',
        role: user.role || 'user',
        is_active: user.is_active !== undefined ? user.is_active : true,
        first_name: user.user_info?.first_name || '',
        last_name: user.user_info?.last_name || '',
        title: user.user_info?.title || '',
        office: user.user_info?.office || '',
        mobile: user.user_info?.mobile || '',
        city: user.user_info?.city || '',
        country: user.user_info?.country || '',
        visibility: user.user_info?.visibility || 0,
        org_id: user.user_info?.org_id || null,
      });
      const avatarValue = user.user_info?.avatar;
      if (avatarValue) {
        setAvatarPreview(avatarValue.startsWith('data:') ? avatarValue : `data:image/jpeg;base64,${avatarValue}`);
      } else {
        setAvatarPreview(null);
      }
      setAvatar(null); // Clear file input when editing
    } else {
      // Create mode - clear everything
      setFormData({
        username: '',
        email: '',
        password: '',
        confirm_password: '',
        role: 'user',
        is_active: true,
        first_name: '',
        last_name: '',
        title: '',
        office: '',
        mobile: '',
        city: '',
        country: '',
        visibility: 0,
        org_id: null,
      });
      setAvatar(null);
      setAvatarPreview(null);
    }
  }, [user]);

  const fetchOesList = async () => {
    try {
      const response = await oesApi.getAll(0, 1000);
      const oesData = response.data || [];
      
      // Fetch assessments to get names
      try {
        const assessmentResponse = await assessmentApi.getAll();
        const assessments = assessmentResponse.data || [];
        const assessmentMap = new Map(assessments.map(a => [a.id, a.name]));
        
        // Enhance OES data with assessment names
        const enhancedOes = oesData.map(oes => ({
          ...oes,
          assessment_name: oes.assessment_id ? assessmentMap.get(oes.assessment_id) : null
        }));
        
        setOesList(enhancedOes);
      } catch (assessmentError) {
        // If assessment fetch fails, use OES data without assessment names
        console.error('Error fetching assessments:', assessmentError);
        setOesList(oesData);
      }
    } catch (error) {
      console.error('Error fetching OES list:', error);
      setOesList([]);
    }
  };

  const fetchOrganizations = async () => {
    try {
      const response = await organizationApi.getAll(0, 1000);
      setOrganizationsList(response.data || []);
    } catch (error) {
      console.error('Error fetching organizations:', error);
      setOrganizationsList([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (user && user.id) {
        // Update existing user
        const userData = {
          email: formData.email,
          role: formData.role,
          is_active: formData.is_active,
        };
        
        // Only include password if it was provided
        if (formData.password) {
          if (formData.password !== formData.confirm_password) {
            throw new Error('Passwords do not match');
          }
          if (formData.password.length < 8) {
            throw new Error('Password must be at least 8 characters long');
          }
          userData.password = formData.password;
        }
        
        await adminApi.updateUser(user.id, userData);

        const userInfoData = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          title: formData.title,
          office: formData.office,
          mobile: formData.mobile,
          city: formData.city,
          country: formData.country,
          visibility: parseInt(formData.visibility),
          org_id: formData.org_id ? parseInt(formData.org_id) : null,
        };
        await adminApi.updateUserInfo(user.id, userInfoData);

        if (avatar) {
          await adminApi.uploadAvatar(user.id, avatar);
        }
      } else {
        // Create new user
        if (!formData.password || formData.password !== formData.confirm_password) {
          throw new Error('Passwords do not match');
        }
        const newuser = {
          username: formData.username,
          email: formData.email,
          password: formData.password,
          role: formData.role,
        };
        const userinfo = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          title: formData.title,
          office: formData.office,
          mobile: formData.mobile,
          city: formData.city,
          country: formData.country,
          visibility: parseInt(formData.visibility),
          org_id: formData.org_id ? parseInt(formData.org_id) : null,
        };
        await adminApi.createUser(newuser, userinfo);
      }

      // Notify parent
      if (onUserUpdated) {
        onUserUpdated();
      }
      onClose();
    } catch (err) {
      const errorDetail = err.response?.data?.detail;
      if (errorDetail && typeof errorDetail === 'object') {
        // Handle structured error response with message and reasons
        let errorMessage = errorDetail.message || 'Failed to save user';
        if (errorDetail.reasons && Array.isArray(errorDetail.reasons) && errorDetail.reasons.length > 0) {
          errorMessage += '\n\nReasons:';
          errorDetail.reasons.forEach((reason, index) => {
            errorMessage += `\n${index + 1}. ${reason}`;
          });
        }
        setError(errorMessage);
      } else {
        // Handle simple string error or fallback
        setError(errorDetail || err.message || 'Failed to save user');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-40 transition-opacity"
        onClick={onClose}
      ></div>

      {/* Sidebar */}
      <div className="fixed right-0 top-0 bottom-0 w-full max-w-2xl bg-white shadow-xl z-50 overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-eucnet-navy">
              {user?.username ? t('common.editUser', { name: user.username }) : t('common.userDetails')}
            </h2>
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-slate-100 text-slate-600"
            >
              <span className="text-xl leading-none">&times;</span>
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600 whitespace-pre-line">
              {error}
            </div>
          )}

          {/* Avatar Section */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.profilePicture')}</label>
            <div className="flex items-center space-x-4">
              <div className="w-20 h-20 rounded-full overflow-hidden bg-slate-200 flex items-center justify-center">
                {avatarPreview ? (
                  <img src={avatarPreview} alt="Avatar" className="w-full h-full object-cover" />
                ) : (
                  <span className="text-2xl text-slate-500">
                    {formData.first_name?.charAt(0)}{formData.last_name?.charAt(0)}
                  </span>
                )}
              </div>
              <div>
                <input
                  type="file"
                  id="avatar"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  className="hidden"
                />
                <label
                  htmlFor="avatar"
                  className="cursor-pointer px-4 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy transition-colors"
                >
                  {t('common.changePhoto')}
                </label>
              </div>
            </div>
          </div>

          {/* Personal Information */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">{t('common.personalInfo')}</h3>
            <div className="grid grid-cols-2 gap-4">
              {/* Password - always visible, required only when creating */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  {t('auth.password')} {!user && <span className="text-red-500">*</span>}
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required={!user}
                  placeholder={user ? t('auth.leaveBlankKeepPassword') : ''}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  {t('auth.confirmPassword')} {!user && <span className="text-red-500">*</span>}
                </label>
                <input
                  type="password"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleInputChange}
                  required={!user}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('auth.username')} *</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                  required
                  disabled={!!user}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent disabled:bg-slate-100"
                />
                {user && (
                  <p className="text-xs text-slate-500 mt-1">{t('auth.usernameCannotChange')}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.firstName')} *</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.lastName')} *</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.email')} *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.role')} *</label>
                <CustomSelect
                  name="role"
                  value={formData.role}
                  onChange={handleInputChange}
                  options={[
                    { value: 'user', label: 'User' },
                    { value: 'assessment_admin', label: 'Assessment Admin' },
                    { value: 'admin', label: 'Admin' },
                    ...(isGlobalAdmin ? [{ value: 'global_admin', label: 'Global Admin' }] : [])
                  ]}
                  placeholder="Select role"
                  required
                />
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">{t('common.contactInfo')}</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Office</label>
                <input
                  type="text"
                  name="office"
                  value={formData.office}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Country</label>
                <CustomSelect
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  options={countries.map(c => ({ value: c.code, label: c.name }))}
                  placeholder="Select country"
                />
              </div>
            </div>
          </div>

          {/* OES Assignment - Only for regular users */}
          {formData.role === 'user' && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-slate-800 mb-4">{`${labels.entityName} Assignment`}</h3>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  {`Assign to ${labels.entityName}`}
                </label>
                <CustomSelect
                  name="org_id"
                  value={formData.org_id ? String(formData.org_id) : ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData(prev => ({
                      ...prev,
                      org_id: value ? parseInt(value) : null
                    }));
                  }}
                  options={[
                    { value: '', label: role === 'admin' ? `Select ${labels.entityName} (required)` : `Select ${labels.entityName} (optional)` },
                    ...oesList.map(oes => ({
                      value: String(oes.id),
                      label: `${oes.name}${oes.assessment_name ? ` (${oes.assessment_name})` : oes.assessment_id ? ` (Assessment #${oes.assessment_id})` : ''}`
                    }))
                  ]}
                  placeholder={`Select ${labels.entityName}`}
                />
                <p className="text-xs text-slate-500 mt-1">
                  {role === 'admin'
                    ? `Regular users must be assigned to an ${labels.entityName} in your organization`
                    : `Assign this user to an ${labels.entityNameFull} organization`}
                </p>
              </div>
            </div>
          )}

          {/* Organization Assignment - For admin and assessment_admin roles */}
          {(formData.role === 'admin' || formData.role === 'assessment_admin') && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-slate-800 mb-4">Organization Assignment</h3>
              <div>
                {role === 'admin' ? (
                  // Organization Admin: Auto-assign to their organization (read-only info)
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-sm text-blue-800">
                      <strong>Automatic Assignment:</strong> This {formData.role === 'admin' ? 'organization admin' : 'assessment admin'} will be automatically assigned to your organization.
                    </p>
                  </div>
                ) : (
                  // Global Admin: Can select organization
                  <>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Assign to Organization
                    </label>
                    <CustomSelect
                      name="org_id"
                      value={formData.org_id ? String(formData.org_id) : ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData(prev => ({
                          ...prev,
                          org_id: value ? parseInt(value) : null
                        }));
                      }}
                      options={[
                        { value: '', label: 'Select Organization (optional)' },
                        ...organizationsList.map(org => ({
                          value: String(org.id),
                          label: `${org.name}${org.short_name ? ` (${org.short_name})` : ''}`
                        }))
                      ]}
                      placeholder="Select Organization"
                    />
                    <p className="text-xs text-slate-500 mt-1">
                      {formData.role === 'admin' 
                        ? 'Assign this organization admin to an organization'
                        : 'Assign this assessment admin to an organization'}
                    </p>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Settings */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">{t('common.settings')}</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('common.profileVisibility')}</label>
                <CustomSelect
                  name="visibility"
                  value={formData.visibility}
                  onChange={handleInputChange}
                  options={[
                    { value: 0, label: 'Not Visible' },
                    { value: 1, label: 'Organization Only' },
                    { value: 2, label: 'All Users' }
                  ]}
                  placeholder="Select visibility"
                />
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="is_active"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleInputChange}
                  className="w-4 h-4 text-eucnet-blue border-slate-300 rounded focus:ring-eucnet-sky"
                />
                <label htmlFor="is_active" className="ml-2 text-sm text-slate-700">
                  {t('common.accountActive')}
                </label>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3 pt-6 border-t border-slate-200">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
            >
              {t('common.cancel')}
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 text-sm font-medium bg-eucnet-sky text-white rounded-lg hover:bg-eucnet-navy transition-colors disabled:opacity-50"
            >
              {loading ? t('common.saving') : user ? t('settings.saveChanges') : t('common.createUser')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default UserEditSidebar;
